import React, { useState } from "react";
import { LogoCenter } from "../../component/LogoCenter";
import arrowNext from "../../images/arrowNext.svg";
import smallArrow from "../../images/smallArrow.svg";
import { Link } from "react-router-dom";

const SignUpAthleteProfile: React.FC = () => {
  const [height, setHeight] = useState("5'55''");
  const [weight, setWeight] = useState("150 lbs");
  const [showHeightDropdown, setShowHeightDropdown] = useState(false);
  const [showWeightDropdown, setShowWeightDropdown] = useState(false);

  const heightOptions = ["5'50''", "5'55''", "6'0''"];
  const weightOptions = ["140 lbs", "150 lbs", "160 lbs"];

  return (
    <div className={`p-[20px] bg-black h-dvh overflow-hidden `}>
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center  overflow-y-auto">
        <LogoCenter />
        <div className="flex flex-col gap-[50px] w-full">
          <div className="flex flex-col justify-center gap-[15px]">
            <h1 className="text-white text-[40px] leading-[95%] font-light uppercase mb-[2px]">
              ATHLETE
              <br />
              PROFILE
            </h1>
            {/* Height Dropdown */}
            <div className="relative">
              <div
                onClick={() => setShowHeightDropdown(!showHeightDropdown)}
                className="flex justify-center items-center gap-5 border border-white focus:outline-none rounded-[45px] bg-transparent text-white text-[32px] !leading-none p-[14px_16px] font-normal cursor-pointer"
              >
                {height}
                <img
                  src={smallArrow}
                  alt="icon"
                  className={`object-contain transform ${
                    showHeightDropdown ? "rotate-360" : "-rotate-90"
                  }`}
                />
              </div>
              {showHeightDropdown && (
                <ul className="absolute top-full left-0 w-full border border-white focus:outline-none rounded-[10px] bg-black text-white mt-2 shadow-lg z-10">
                  {heightOptions.map((option) => (
                    <li
                      key={option}
                      onClick={() => {
                        setHeight(option);
                        setShowHeightDropdown(false);
                      }}
                      className="px-4 py-2 text-white hover:bg-gray-900 cursor-pointer rounded-[10px] overflow-hidden"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Weight Dropdown */}
            <div className="relative">
              <div
                onClick={() => setShowWeightDropdown(!showWeightDropdown)}
                className="flex justify-center items-center gap-5 border border-white focus:outline-none rounded-[45px] bg-transparent text-white text-[32px] !leading-none p-[14px_16px] font-normal cursor-pointer"
              >
                {weight}
                <img
                  src={smallArrow}
                  alt="icon"
                  className={`object-contain transform ${
                    showWeightDropdown ? "rotate-360" : "-rotate-90"
                  }`}
                />
              </div>
              {showWeightDropdown && (
                <ul className="absolute top-full left-0 w-full border border-white focus:outline-none rounded-[10px] bg-black text-white mt-2 shadow-lg z-10">
                  {weightOptions.map((option) => (
                    <li
                      key={option}
                      onClick={() => {
                        setWeight(option);
                        setShowWeightDropdown(false);
                      }}
                      className="px-4 py-2 hover:bg-gray-900 cursor-pointer rounded-[10px] overflow-hidden"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <Link
            to="/signupathletegolas"
            className="bg-white size-[70px] rounded-full flex justify-center items-center hover:bg-white/50 transition-all duration-300 ml-auto"
          >
            <img src={arrowNext} alt="arrow" className="object-contain" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignUpAthleteProfile;
